/* global app */
export const getEventThumbnail = (id, urls) => {
    if (app !== 'pixellot-you') {
        return null;
    }

    const streamUrl = urls && urls.hd;

    if (!streamUrl) {
        return null;
    }

    const internalId = streamUrl.split('/')[4];
    const [basePath] = streamUrl.split(internalId);

    return `${basePath}${internalId}/local/${internalId}.png`;
};
